<template>
  <div class="login container">
    <img class="logo" alt="lts logo" src="../assets/logo.png" />
    <div class="login-card">
      <div class="login-card-header">Login to your account</div>
      <div class="login-card-body">
        <form @submit.prevent="login">
          <div v-show="error" class="error">{{ error }}</div>
          <div v-show="!isLimitExceeded">
            <div class="mb-3">
              <label for="username">Username</label>
              <input id="username" v-model="username" class="textbox mt-1" type="text" />
              <small v-show="username_invalid" class="required">Please enter a username</small>
            </div>
            <div class="mb-3">
              <label for="password">Password</label>
              <input id="password" v-model="password" class="textbox mt-1" type="password" />
              <small v-show="password_invalid" class="required">Please enter a password</small>
            </div>
            <input v-show="!isLoggingIn" type="submit" value="Login" class="btn btn-login" />
            <Loader v-show="isLoggingIn" class="loader"></Loader>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Loader from "@/components/Loader.vue";
import axios from "axios";

export default {
  name: "Login",
  components: {
    Loader
  },
  data: () => {
    return {
      isLoggingIn: false,
      isLimitExceeded: false,
      username: "",
      password: "",
      username_invalid: false,
      password_invalid: false,
      error: ""
    };
  },
  methods: {
    login: function() {
      this.isLoggingIn = true;
      this.isLimitExceeded = false;
      this.error = "";

      // Validation
      this.username.trim().length > 0
        ? (this.username_invalid = false)
        : (this.username_invalid = true);

      this.password.trim().length > 0
        ? (this.password_invalid = false)
        : (this.password_invalid = true);

      if (this.username_invalid || this.password_invalid) {
        this.isLoggingIn = false;
        return;
      }

      // Call the login api
      axios
        .post("/auth", { username: this.username, password: this.password })
        .then(response => {
          this.isLoggingIn = false;
          this.isLimitExceeded = false;

          // Save the Jwt Token for later api requests
          localStorage.token = response.data;
          axios.defaults.headers.common["Authorization"] =
            "Bearer " + response.data;
          this.$router.push("/links");
        })
        .catch(err => {
          this.isLoggingIn = false;
          this.isLimitExceeded = false;
          if (err.response.status === 400) {
            this.error = err.response.data;
            if (this.error.trim().toLowerCase().startsWith("exceeded")) {
              this.isLimitExceeded = true;
            }
          } else {
            this.error = "Internal error occured. Please contact LTS support.";
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
/* IMPORT VARIABLES */
@import "@/styles/_variables.scss";

.login {
  max-width: 500px;
  margin: 0 auto;
}

.login-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  border: 1px solid #d3d3d3;
}

.login-card-header {
  font-weight: bold;
  padding: 1.5rem;
  color: white;
  background: $primary-color;
}

.login-card-body {
  padding: 2rem;
}

.btn-login {
  display: block;
  background: $primary-color;
  color: $white-color;
  font-weight: bold;
  width: 50%;
  margin: 0 auto;

  &:hover {
    background: #5e85d8;
  }
}

.logo {
  display: block;
  width: 100px;
  margin: 50px auto;
}

.error {
  color: $danger-color;
  text-align: center;
  font-size: 0.9rem;
  margin-bottom: 2rem;
  padding: 0.5rem;
  border: 1px solid $danger-color;
  border-radius: 3px;
}

.loader {
  width: 4rem;
  margin: 0 auto;
}

.required {
  display: block;
  color: $danger-color;
}
</style>
